import { sendMetric } from '@atheneum/api/dist/lib';
import { IconUpdate } from "../../components/IconUpdate"; // Global States for faster scheduling

import { useStore } from "../../contexts/store";
import { format } from 'date-fns';
import moment from 'moment';
import React from 'react';
import { uuid } from 'uuidv4';

const RenderMatch = ({
  growlStore
}) => {
  const {
    state,
    dispatch
  } = useStore();
  const {
    firstMatch,
    submitFirstMatch,
    schedule,
    duration,
    takenExpertSlots
  } = state;
  const startTime = firstMatch;
  const endTime = firstMatch + 1000 * 60 * duration;
  let day = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 19,
      color: '#fff',
      fontWeight: '400'
    }
  }, moment(startTime).format('ddd').toUpperCase(), ","), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 19,
      lineHeight: '25px',
      fontWeight: '400'
    }
  }, moment(startTime).format('Do')), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 17
    }
  }, format(startTime, 'MMMM yyyy')));
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: window && window.outerWidth < 768 ? '100%' : 'auto',
      display: 'flex',
      margin: '4px',
      zIndex: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    title: "Edit Timeslot",
    className: `slice-wrapper first_match`,
    onClick: () => {
      dispatch({
        type: 'UPDATE',
        payload: {
          dayToRender: moment(firstMatch),
          readOnly: true,
          currentPath: 'calendarview'
        }
      });
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      left: '9px',
      top: '9px'
    }
  }, /*#__PURE__*/React.createElement(IconUpdate, null)), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      width: '150px'
    }
  }, day), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 19,
      fontWeight: '400',
      marginLeft: 8,
      paddingLeft: 8,
      alignItems: 'center',
      display: 'flex',
      borderLeft: window && window.outerWidth < 768 ? '0' : '2px solid rgba(255,255,255,.8)',
      justifyContent: 'center',
      flexDirection: 'column',
      width: '150px'
    }
  }, /*#__PURE__*/React.createElement("div", null, format(startTime, 'HH:mm')), /*#__PURE__*/React.createElement("div", null, format(endTime, 'HH:mm')), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 16,
      color: 'rgba(255,255,255,1)'
    }
  }, "(", format(startTime, 'zzzz'), ")"))), /*#__PURE__*/React.createElement("div", {
    className: "close-wrapper confirmFirstMatch",
    title: "Select Timeslot",
    onClick: () => {
      const startTimes = takenExpertSlots.map(slot => parseInt(moment(slot.startTime).format('x')));
      const endTimes = takenExpertSlots.map(slot => parseInt(moment(slot.endTime).format('x')));
      const start = startTime;
      const end = endTime;
      const startTimeCheck = startTimes.every(startTime => {
        return start <= startTime && end > startTime;
      });
      const endTimesCheck = endTimes.every(endTime => {
        return start < endTime && end >= endTime;
      });
      const freeSlot = !startTimeCheck && !endTimesCheck;

      if (takenExpertSlots.length && !freeSlot) {
        growlStore.showError('Slot is already taken for this expert.');
        sendMetric('scheduling.SlotTaken', 'scheduling', {
          errror: 'error'
        });
        return;
      }

      const timeSlot = {
        drafts: [],
        duration,
        id: uuid(),
        time: {
          start: startTime,
          end: endTime
        }
      };
      dispatch({
        type: 'SETSCHEDULE',
        payload: {
          schedule: { ...schedule,
            timeslots: [timeSlot]
          }
        }
      });
      dispatch({
        type: 'UPDATE',
        payload: {
          submitFirstMatch: !submitFirstMatch
        }
      });
    }
  }, /*#__PURE__*/React.createElement("input", {
    className: "first_match_input_checked",
    type: "checkbox",
    readOnly: true,
    checked: !submitFirstMatch
  })));
};

export default RenderMatch;